import { Route } from '@tanstack/react-location';
import React, { lazy } from 'react';

import { AdminRouteBaseProps } from '@/layout/Admin/routes';

export type SubscriptionClientsAdminRouteProps = AdminRouteBaseProps;

const SubscriptionClientsAdmin = lazy(() => import('./index'));

const SubscriptionClientsAdminRoutes: Route<SubscriptionClientsAdminRouteProps>[] =
  [
    {
      path: 'subscription',
      id: 'SubscriptionClientsAdmin',
      element: <SubscriptionClientsAdmin />,
      meta: {
        breadcrumbs: () => ({
          breadcrumb: 'Prenumerationskunder',
        }),
      },
    },
  ];

export const toSubscriptionClientsAdmin = (): string => '/admin/subscription';

export default SubscriptionClientsAdminRoutes;
